<template>
  <div class="space-y-6">
    <!-- Header with Sacred Geometry Image -->
    <div class="flex items-center justify-between">
      <div class="h-1 flex-1 bg-primary/20 rounded"></div>
      <img src="https://firebasestorage.googleapis.com/v0/b/aline-perim-prod.appspot.com/o/images%2Fflower-life-sacred-geometry.webp?alt=media&token=851535c9-cfb0-4264-8369-c7d0795b2d01" class="w-30 h-10 mx-3" />
      <div class="h-1 flex-1 bg-primary/20 rounded"></div>
    </div>

    <!-- Main Content -->
    <div class="bg-white rounded-lg overflow-hidden">
      <div class="relative">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/aline-perim-prod.appspot.com/o/images%2Fbanner-1.webp?alt=media&token=612de045-02f5-4d81-9c71-00431bc0709c"
          alt="Sacred Geometry"
          class="w-full h-48 object-cover"
        />
        <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
      </div>

      <div class="p-6">
        <h3 class="text-2xl font-bold text-primary-dark mb-4">
          Seu Número da Motivação é: {{ number }}
        </h3>

        <p class="text-gray-700 mb-6">
          {{ description }}
        </p>

        <div class="bg-primary/5 rounded-lg p-4">
          <div class="flex flex-col md:flex-row md:items-start gap-4">
            <div>
              <p class="font-medium text-primary-dark mb-2">O que o Número de Motivação revela sobre você?</p>
              <p class="text-sm text-gray-600">
                O número da motivação (também chamado de sonho) é a energia que mais valorizamos e buscamos ao longo da vida. Todo ser humano idealiza muitas coisas, ter dinheiro, casar, ter uma carreira e etc. Porém o número da motivação é a energia que mais necessitamos equilibrar em nossas vidas. A realização de todas as outras intenções são baseadas no foco e vivencia do caminho de destino.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CTA Button -->
    <button
      @click="$emit('next')"
      class="w-full py-4 px-6 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors flex items-center justify-center gap-2"
    >
      <span>Continuar</span>
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getMotivationDescription } from '@/utils'

const props = defineProps<{
  number: number
}>()

const description = computed(() => getMotivationDescription(props.number))

defineEmits(['next'])
</script>